import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, GatsbyImageProps } from 'gatsby-plugin-image'

import RoamingMapComponent from '@slice/mobile-roaming-map'

type RoamingMapOptionsConfig = {
    heading: string,
    body: string
}

const RoamingMap: React.FC<RoamingMapOptionsConfig> = ({ ...props }) => {
    const site: string = process.env.GATSBY_SITE ?? 'residential';
    let { [site]: { nodes: rates }, image } = useStaticQuery(query);

    if(image) {
        image =
        <GatsbyImage
            objectFit='contain'
            objectPosition={'bottom center'}
            className="md:w-52 mt-auto lg:top-64 h-auto"
            loading="lazy"
            image={getImage(image.r.image.file.sharp)}
            {...image.meta}
        />
    }

    return (
        <RoamingMapComponent rates={rates} image={image} {...props} />
    )
}
export default RoamingMap


const query = graphql`
    query {
        residential:allTaxonomyTermMobileRoamingRates(
            sort: {weight: ASC}
            filter: {relationships: {field_site: {name: {eq: "Residential"}}}}
        ) {
            nodes {
                tid:drupal_internal__tid
                name
                field_shoulder
              	cost:field_cost
              	cost_suffix:field_cost_suffix
                description {
                    html:processed
                }
                code:field_codes
                legend:field_cc_code {
                    html:processed
                }
                smallprint:field_smallprint {
                    html:processed
                }
                r:relationships {
                    parent {
                        tid:drupal_internal__tid
                    }
                    theme:field_theme {
                        name
                    }
                }
            }
        }

        business:allTaxonomyTermMobileRoamingRates(
            sort: {weight: ASC}
            filter: {relationships: {field_site: {name: {eq: "Business"}}}}
        ) {
            nodes {
                tid:drupal_internal__tid
                name
                field_shoulder
              	cost:field_cost
              	cost_suffix:field_cost_suffix
                description {
                    html:processed
                }
                code:field_codes
                legend:field_cc_code {
                    html:processed
                }
                smallprint:field_smallprint {
                    html:processed
                }
                r:relationships {
                    parent {
                        tid:drupal_internal__tid
                    }
                    theme:field_theme {
                        name
                    }
                }
            }
        }

        image:mediaImage(drupal_internal__mid: {eq: 407}) {
            meta:field_media_image {
                alt
                height
                width
            }
            r:relationships {
                image:field_media_image {
                    file:localFile {
                        sharp:childImageSharp {
                            gatsbyImageData(
                                placeholder: NONE,
                                width: 480,
                                formats: [PNG, AVIF]
                            )
                        }
                    }
                }
            }
        }

    }
`